import { useTranslation } from 'react-i18next';

import { LANGUAGES, LANG_STORAGE_KEY, type LanguageCode } from '@/i18n';

export default function LanguagePicker() {
  const { i18n } = useTranslation();
  const current = (i18n.resolvedLanguage ?? i18n.language ?? 'ro') as LanguageCode;
  const change = (code: LanguageCode) => {
    void i18n.changeLanguage(code);
    try {
      localStorage.setItem(LANG_STORAGE_KEY, code);
    } catch {
      // storage indisponibil — ignore
    }
  };
  return (
    <div className="flex gap-2 flex-wrap">
      {LANGUAGES.map((l) => (
        <button
          key={l.code}
          type="button"
          onClick={() => change(l.code)}
          className={`btn-outline text-xs flex-1 ${
            current === l.code
              ? 'bg-brand-50 text-brand-700 border-brand-300 dark:bg-brand-900/30 dark:text-brand-300 dark:border-brand-700'
              : ''
          }`}
        >
          {l.label}
        </button>
      ))}
    </div>
  );
}
